import { Box } from '@mui/material';
import '../ChartFilterGroup.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import ChartFilterGroupList from './ChartFilterGroupList';
import ReportFilterHeaderWithGroupMenu from './ReportFilterHeaderWithGroupMenu';
import React, { useMemo, useEffect } from 'react';

interface Props {
  propKey: string;
  fromDashboard: boolean;
  reportFilterMenu?: boolean;
  setReportFilterMenu?: (value: boolean) => void;

  backgroundColor?: string;
  color?: string;
}

/**
 * @returns This component comprises a container, containing a header(ReportFilterHeaderWithGroupMenu.tsx) and list of groups in the filter(ChartFilterGroupList.tsx).
 */
const ChartFilterGroupsContainer = ({
  propKey,
  fromDashboard,
  reportFilterMenu,
  setReportFilterMenu,

  backgroundColor,
  color,
}: Props) => {
  const { tabTileProps, chartFilterGroup, parameterState } = useSelector((state: RootState) => ({
    tabTileProps: state.tabTileProps,
    chartFilterGroup: state.chartFilterGroup,
    parameterState: state.parameters,
  }));

  const [manualReportFilterMenu, setManualReportFilterMenu] = React.useState(true);

  const shouldDefaultOpen = useMemo(() => {
    const hasFilters = Object.values(chartFilterGroup.groups || {}).some(
      (group: any) => group.filters && group.filters.length > 0,
    );

    return hasFilters;
  }, [chartFilterGroup, parameterState]);

  useEffect(() => {
    if (tabTileProps.dashMode === 'Present' && setReportFilterMenu) {
      setReportFilterMenu(shouldDefaultOpen);
    }
  }, [tabTileProps.dashMode, setReportFilterMenu, shouldDefaultOpen]);

  return (
    <Box
      className="chartFilterGroupContainer"
      sx={{
        backgroundColor: backgroundColor,
        padding: '10px 0px 0px 0px',
        paddingLeft: fromDashboard ? '0px !important' : '10px !important',
        paddingRight: tabTileProps.showDash ? '0.3rem' : 'auto',
        '@supports ((-moz-appearance: none))': {
          paddingInline: '4px',
          paddingRight: tabTileProps.showDash ? '0.7rem' : 'auto',
        },
      }}
    >
      <ReportFilterHeaderWithGroupMenu
        propKey={propKey}
        fromDashboard={fromDashboard}
        reportFilterMenu={reportFilterMenu}
        setReportFilterMenu={setReportFilterMenu}
        manualReportFilterMenu={manualReportFilterMenu}
        setManualReportFilterMenu={setManualReportFilterMenu}
        color={color}
        backgroundColor={backgroundColor}
      />

      <ChartFilterGroupList
        propKey={propKey}
        fromDashboard={fromDashboard}
        reportFilterMenu={reportFilterMenu}
        setReportFilterMenu={setReportFilterMenu}
        manualReportFilterMenu={manualReportFilterMenu}
        setManualReportFilterMenu={setManualReportFilterMenu}
        color={color}
        backgroundColor={backgroundColor}
      />
    </Box>
  );
};

export default ChartFilterGroupsContainer;
